import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/engagement/register-panels'
import '../../../modules/events/register-panels'
import { EngagementEventFullPage } from '../../../modules/engagement/engagement-event-full-page'
import { EventFullPage } from '../../../modules/events/event-full-page'
import { PANEL_TYPES } from '../../../shell/panel-state'

const detailSearchSchema = z.object({
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  pstack: z.string().optional(),
})

export const Route = createFileRoute('/_authed/engagement/$eventId')({
  validateSearch: detailSearchSchema,
  component: EventDetailRoute,
})

function EventDetailRoute() {
  const { eventId } = Route.useParams()
  // The Activities stream lists analytics events (`evt_`); the legacy marketing
  // events keep their `enge_` ids. Both open under /engagement, so dispatch on
  // the branded id prefix.
  if (eventId.startsWith('evt_')) {
    return <EventFullPage eventId={eventId} fallbackTo="/engagement" fallbackLabel="Activities" />
  }
  return <EngagementEventFullPage eventId={eventId} />
}
